<template>
  <div class="body-1" @click="onClick">
    <v-row class="d-flex">
      <v-col cols="1">
        <v-checkbox :input-value="productWrapper.selected" @click.prevent />
      </v-col>
      <v-col cols="10" class="mt-2 ml-4">
        <v-row class="align-center">
          <v-col cols="6">{{ productWrapper.product.name }}</v-col>
          <v-col cols="4" class="d-flex justify-end">
            <v-chip
              v-for="(option, i) in productWrapper.product.options"
              :key="i"
              small
              outlined
              exact
              class="body-2 font-italic"
            >
              {{ option.name }}
            </v-chip>
          </v-col>
          <v-col cols="2" class="d-flex justify-end">
            {{
              calculatePrice(productWrapper.product).toLocaleString(
                $t("Current locale"),
                {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                }
              )
            }}€
          </v-col>
        </v-row>
        <span v-if="productWrapper.product.comment" class="body-2 font-italic">
          {{ productWrapper.product.comment }}
        </span>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: ["productWrapper"],
  methods: {
    calculatePrice(product) {
      let price = product.price;
      if (product.options) {
        product.options.forEach(option => (price += option.addedPrice));
      }
      return price;
    },
    onClick() {
      this.$emit("clicked", this.productWrapper);
    }
  }
};
</script>

<style></style>
